module.exports = __webpack_public_path__ + "static/media/circle-and-check-green.b6a30fd7.svg";